/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAcceptInvitationInput = {
    clientMutationId?: string | null;
    token: string;
    password: string;
};
export type InvitationAcceptanceFormAcceptAccountMutationVariables = {
    input: infoAcceptInvitationInput;
};
export type InvitationAcceptanceFormAcceptAccountMutationResponse = {
    readonly infoAcceptInvitation: {
        readonly clientMutationId: string | null;
    } | null;
};
export type InvitationAcceptanceFormAcceptAccountMutation = {
    readonly response: InvitationAcceptanceFormAcceptAccountMutationResponse;
    readonly variables: InvitationAcceptanceFormAcceptAccountMutationVariables;
};



/*
mutation InvitationAcceptanceFormAcceptAccountMutation(
  $input: infoAcceptInvitationInput!
) {
  infoAcceptInvitation(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAcceptInvitationPayload",
    "kind": "LinkedField",
    "name": "infoAcceptInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitationAcceptanceFormAcceptAccountMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitationAcceptanceFormAcceptAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0747f8c53600d52493b1e8d22e228d6c",
    "id": null,
    "metadata": {},
    "name": "InvitationAcceptanceFormAcceptAccountMutation",
    "operationKind": "mutation",
    "text": "mutation InvitationAcceptanceFormAcceptAccountMutation(\n  $input: infoAcceptInvitationInput!\n) {\n  infoAcceptInvitation(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '784cdf99481743ffbfd8f53890e46925';
export default node;
